import { type CurrencyCode, type LocalDate, type Money, zeroMoney } from '@taler/domain'
import type { CashFlowPeriod } from '@taler/api-client'
import { bucketStarts, type ReportRange } from './report-range.ts'

export interface ChartPeriod {
  readonly start: LocalDate
  readonly income: Money
  readonly expense: Money
  readonly net: Money
}

/** Every bucket in the window, oldest first; a bucket the server left out reads as zero. */
export function chartPeriods(
  periods: readonly CashFlowPeriod[],
  range: ReportRange,
  currency: CurrencyCode,
): ChartPeriod[] {
  const byStart = new Map(periods.map((period) => [period.periodStart.epochDay, period]))
  return bucketStarts(range).map((start) => {
    const period = byStart.get(start.epochDay)
    if (period !== undefined)
      return { start, income: period.income, expense: period.expense, net: period.net }
    const zero = zeroMoney(currency)
    return { start, income: zero, expense: zero, net: zero }
  })
}
